<template>
  <div>
    <b-field label="Abonnenten">
      <b-table
        :data="topLevels"
        ref="table"
        detailed
        custom-detail-row
        style="border: 1px solid #dbdbdb; border-radius: 4px"
        :height="height"
        :sticky-header="scrollable"
        :has-detailed-visible="isParent"
        :mobile-cards="false"
      >
        <b-table-column
          field="name"
          label="Organisation"
          sortable
          v-slot="props"
        >
          <div class="is-flex">
            <b-icon
              :type="!props.row.locked ? 'is-success' : 'is-danger'"
              icon-pack="fas"
              icon="circle"
              class="mr-2"
            ></b-icon>
            <p class="mb-0">{{ props.row.name }}</p>
          </div>
        </b-table-column>
        <b-table-column
          field="license_type"
          label="Lizenz"
          sortable
          v-slot="props"
        >
          <OrgTag :data="props.row.license_type" :test="props.row.test" />
        </b-table-column>
        <b-table-column field="action" label="" width="40" v-slot="props">
          <router-link
            :to="{ name: 'ViewOrg', params: { orgId: props.row.id } }"
          >
            <b-icon icon="arrow-right" icon-pack="fas"></b-icon>
          </router-link>
        </b-table-column>

        <template slot="detail" slot-scope="props">
          <tr v-for="subOrg in subLevelOf(props.row.id)" :key="subOrg.id">
            <td></td>
            <td>
              <div class="is-flex" style="padding-left: 30px">
                <b-icon
                  :type="!subOrg.locked ? 'is-success' : 'is-danger'"
                  icon-pack="fas"
                  icon="circle"
                  class="mr-2"
                ></b-icon>
                <p class="mb-0">{{ subOrg.name }}</p>
              </div>
            </td>
            <td>
              <OrgTag :data="subOrg.license_type" :test="subOrg.test" />
            </td>
            <td>
              <router-link
                :to="{ name: 'ViewOrg', params: { orgId: props.row.id } }"
              >
                <b-icon icon="arrow-right" icon-pack="fas"></b-icon>
              </router-link>
            </td>
          </tr>
        </template>
      </b-table>
    </b-field>
  </div>
</template>

<script>
import OrgTag from '@/components/editOrg/OrgTag.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'ProductOrgs',
  props: {
    subscriberId: {
      type: Array,
      required: true,
    },
    height: {
      type: Number,
      required: false,
      default: 300,
    },
    scrollable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    OrgTag,
  },
  computed: {
    ...mapGetters({
      orgById: 'org/dataById',
    }),
    mainOrgIds() {
      const isMainOrg = (orgId) => this.orgById(orgId).license_type === 'main';
      return this.subscriberId.filter(isMainOrg);
    },
    topLevels() {
      const isTopLevel = (org) => {
        const isMain = org.license_type === 'main';
        const isSubWithoutMain = org.license_type === 'sub' && !this.mainOrgIds.includes(org.main_license_org_id);
        return isMain || isSubWithoutMain;
      };

      return this.subscriberId.map(this.orgById).filter(isTopLevel);
    },
  },
  methods: {
    subLevelOf(mainOrgId) {
      const isSubLevelOf = (org) => org.license_type === 'sub' && org.main_license_org_id === mainOrgId;
      return this.subscriberId.map(this.orgById).filter(isSubLevelOf);
    },
    isParent(org) {
      const parent = (theOrg) => theOrg.main_license_org_id;
      const parentIds = this.subscriberId
        .map(this.orgById)
        .filter(parent)
        .map(parent);
      return parentIds.includes(org.id);
    },
  },
};
</script>

<style>
</style>
